/** @format */
import { SubmissionErrorCode } from '@toucan/types';
import { Checkout } from '@toucan/types/mpbx/checkout';

export enum TransactionAddressType {
    USE_ADDRESS_BOOK = 'use-address-book',
    USE_BILLING_ADDRESS = 'use-billing-address',
    USE_HOME_ADDRESS = 'use-home-address',
    USE_NEW_ADDRESS = 'use-new-address',
    USE_DHL_PACKSTATION = 'use-dhl-packstation',
}

export enum CheckoutSubmissionErrorType {
    CREATE = 'create',
    BILLING_ADDRESS = 'billingAddress',
    SHIPPING_OPTION = 'shippingOption',
    SHIPPING_ADDRESS = 'shippingAddress',
    DISCOUNT = 'discount',
    PAYMENT = 'payment',
    WARRANTY = 'warranty',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface CheckoutSubmissionError {
    type: CheckoutSubmissionErrorType;
    code: SubmissionErrorCode;
    title?: string;
    message?: string;
    details?: Record<string, any>;
}

export type PaymentOrOutbound =
    | CheckoutInBoundPaymentFormValues
    | Partial<CheckoutOutBoundPaymentFormValues>
    | false; // False in the event there is no payment applicable

export type CheckoutInBoundPaymentFormValues = {
    token?: string;
    paymentGateway: PaymentGatewayType;
    checkoutType: CheckoutType;
    deviceData?: string;
};

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface CheckoutOutBoundPaymentFormValues {
    /**
     * UK account number
     */
    accountNumber: string;

    /**
     * UK account sort code
     */
    sortCode: string;

    /**
     * US account number
     */
    usAccountNumber: string;

    /**
     * US routing number
     */
    routingNumber: string;

    /**
     * International IBAN details
     */
    iban: string;

    /**
     * International SWIFT details
     */
    swift: string;
}

/**
 * @deprecated use PaymentMethodType instead
 */
export enum PaymentMethod {
    CARD = 'card',
    PAYPAL = 'paypal',
    PAYPAL_CREDIT = 'paypalCredit',
}

export enum CheckoutType {
    PAYPAL = 'paypal',
    PAYPAL_CREDIT = 'paypalCredit',
    CARD = 'card',
    IDEAL = 'ideal',
    EPS = 'eps',
    BANCONTACT = 'bancontact',
    BALANCE = 'balance',
}

export enum PaymentGatewayType {
    BRAINTREE = 'BRAINTREE',
    STRIPE = 'STRIPE',
    MPB = 'MPB',
}

export enum CheckoutGatewayType {
    BRAINTREE = 'BRAINTREE',
    STRIPE = 'STRIPE',
    MIXED = 'MIXED',
}

export type PaymentMethodInfo = {
    name: PaymentMethodType;
    options: {
        capturedMethod?: 'manual' | 'automatic';
        brands?: string[];
    };
};

export enum PaymentMethodType {
    CARD = 'CARD',
    PAYPAL = 'PAYPAL',
    IDEAL = 'IDEAL',
    EPS = 'EPS',
    BANCONTACT = 'BANCONTACT',
    SELL_BALANCE = 'SELL_BALANCE',
}

export type PaymentGateway = {
    name: PaymentGatewayType;
    methods: PaymentMethodInfo[];
};

export type OnCheckoutComplete = (id: string) => Promise<void>;

export type CheckoutResponse = Checkout & {
    marketId: number;
};
